import { render, staticRenderFns } from "./EditService.vue?vue&type=template&id=fc3bde38&scoped=true"
import script from "./EditService.vue?vue&type=script&lang=js"
export * from "./EditService.vue?vue&type=script&lang=js"
import style0 from "./EditService.vue?vue&type=style&index=0&id=fc3bde38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3bde38",
  null
  
)

export default component.exports